import { render, staticRenderFns } from "./IconDisplay.vue?vue&type=template&id=3f7825ff&"
import script from "./IconDisplay.vue?vue&type=script&lang=ts&"
export * from "./IconDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports